import {MenuItem} from 'primeng/api';
import {ReactedWithEnum} from '../../core/enums/reacted-with.enum';
import {ReactedWithToEmojiMapper} from '../../core/helpers/reacted-with-to-emoji.mapper';

export function createReactionMenu(select: (reaction: ReactedWithEnum) => void, includeLaugh = false): MenuItem[] {
  return [ReactedWithEnum.FIRE, ReactedWithEnum.HEART, ReactedWithEnum.THUMBS_UP, ReactedWithEnum.FACE_SURPRISE,
    ...(includeLaugh ? [ReactedWithEnum.FACE_LAUGH] : [])]
    .map(reaction => ({
      state: {emoji: ReactedWithToEmojiMapper.map(reaction)},
      command: () => select(reaction),
    }));
}
